import { render } from "./TSAVideoPanel.vue?vue&type=template&id=44abee30&scoped=true"
import script from "./TSAVideoPanel.vue?vue&type=script&lang=js"
export * from "./TSAVideoPanel.vue?vue&type=script&lang=js"

import "./TSAVideoPanel.vue?vue&type=style&index=0&id=44abee30&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44abee30"]])

export default __exports__